// extracted by mini-css-extract-plugin
export var container = "_e8-0";
export var icon = "_e8-1";
export var text = "_e8-2";